import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { Page } from 'models/page';

@Component({
  selector: 'ngx-lesson-submition-dialog',
  templateUrl: './lesson-submition-dialog.component.html',
  styleUrls: ['./lesson-submition-dialog.component.scss'],
})
export class LessonSubmitionDialogComponent implements OnInit {
  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    index: new FormControl(0, [Validators.required]),
    is_published: new FormControl(false, [Validators.required]),
    is_free: new FormControl(false, [Validators.required]),
  });

  data: Partial<Page> = {};

  constructor(protected ref: NbDialogRef<LessonSubmitionDialogComponent>) {}

  ngOnInit(): void {
    this.form.patchValue(this.data);
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    if (this.form.invalid) return;
    this.ref.close(this.form.value);
  }

  get $nameControl() {
    return this.form.get('name') as FormControl;
  }
  get $indexControl() {
    return this.form.get('index') as FormControl;
  }
  get $isPublishedControl() {
    return this.form.get('is_published') as FormControl;
  }
}
